import store from '@/store'

export default async (to, from, next) => {
  const user = store.getters['auth/user']
  if (user.role !== 'ta') {
    next({ name: `${user.role}.dashboard` })
  } else {
    next()
  }
}
